import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyBYBw-Eunbif2v060GYGOGErCywd9H7k6s",
    authDomain: "whatsapp-clone-1b0dd.firebaseapp.com",
    databaseURL: "https://whatsapp-clone-1b0dd.firebaseio.com",
    projectId: "whatsapp-clone-1b0dd",
    storageBucket: "whatsapp-clone-1b0dd.appspot.com",
    messagingSenderId: "881936276912",
    appId: "1:881936276912:web:26158d88480930b636ca75",
    measurementId: "G-GRRC2J7K6G"
  };


const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth;
const provider = new firebase.auth.GoogleAuthProvider();

export {auth, provider};
export default db;